var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentBtnIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_16444)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1919 2.64941H5.80025C3.66825 2.64941 1.93359 4.38372 1.93359 6.51607V18.9954C1.93359 21.123 3.66064 22.8545 5.78654 22.8621V28.5249L13.9248 22.862H26.1919C28.3239 22.862 30.0586 21.1274 30.0586 18.9953V6.51607C30.0586 4.38372 28.3239 2.64941 26.1919 2.64941ZM28.4106 18.9953C28.4106 20.2186 27.4154 21.2141 26.1919 21.2141H13.4078L7.43449 25.3707V21.2141H5.80025C4.57682 21.2141 3.58154 20.2186 3.58154 18.9953V6.51607C3.58154 5.2925 4.57682 4.29736 5.80025 4.29736H26.1919C27.4154 4.29736 28.4106 5.2925 28.4106 6.51607V18.9953Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45898 8.47217H22.5289V10.1201H9.45898V8.47217ZM9.45898 11.9878H22.5289V13.6357H9.45898V11.9878ZM9.45898 15.5034H22.5289V17.1514H9.45898V15.5034Z",
    fill: "#565656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_16444"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.5 0.281616)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentBtnIcon);
export default __webpack_public_path__ + "static/media/comment-btn-icon.76f909078fd0f1a76b009bb779f838f9.svg";
export { ForwardRef as ReactComponent };